<template>
<div> 
  <main class="container-fluid"> 
    <section class="row">
      <div class='col-4 px-3 py-3 d-none d-md-flex'></div>
      <div class='col-24 col-md-11 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5'>
        <div class='col d-column'>
          <h1 class="title pt-2 mb-0" v-text="$ml.get('progTitle')"></h1>
          <h1 class="title"><span v-text="$ml.get('progSubTitle')" class="pb-2"></span></h1> 
           
          <div class="card mb-3"> 
            <div class="card-body card-chart-body"> 
              <div class="row">
                <div class="col-8 border-r-d mt-2 mb-2">
                  <span class="pb-1" v-text="$ml.get('approvedReports')"></span>
                  <h6> {{ approved_reports }} </h6>
                </div>
                <div class="col-8 border-r-d pl-3 mt-2 mb-2">
                  <span class="pb-1" v-text="$ml.get('scope')"></span>
                  <h6> {{amount_of_scopes}} </h6>
                </div>
                <div class="col-8 pl-3 mt-2 mb-2">
                  <span class="pb-1" v-text="$ml.get('navAverage')"></span>
                  <h6> {{ mediaRecomp }} </h6>
                </div>
              </div>
            </div>
          </div>  
 
          <div class="mb-3" v-show="listProgram.length">
            <div class='card'>
              <div class='card-header' v-text="$ml.get('program')+'s'"> Programas </div>

              <div class='mb-2 px-3' v-for="(item, index) in listProgram" :key="index"> 
                <div class='d-column flex-row'>
                  <div class=' no mt-3  d-flex flex-column pb-3 align-items-start'>
                    <div class='d-flex align-self-start d-flex flex-row align-items-start justify-content-start w-100' > 
                      <div class="mr-3" width="62">
                        <object width="62" height="62" class="rounded-circle img-lg" :data="item.avatar" type="image/png">
                          <img width="62" height="62" class="rounded-circle img-lg" src="../../../assets/images/default.png" alt="Avatar">
                        </object> 
                      </div>
                      <div class='d-flex w-100'> 
                        <div class='align-self-start mt-1 w-100'>
                          <div class='row d-flex justify-content-between align-self-center'>
                            <h6 class='col pb-1'>
                              <router-link :to=" '/program/detail?'+item._id" class='link-block' >
                                <strong v-text="item.name"></strong>
                              </router-link>
                            </h6>
                            <div class="ml-2">
                              <a class="badge badge-warning text-white" v-if="item.status =='pending'" v-text="$ml.get('pending')">Pendente</a>
                              <a class="badge badge-success text-white" v-show="item.status =='in_progress'" v-text="$ml.get('inProgress')">Em andamento</a>
                              <a class="badge badge-secondary text-white" v-show="item.status =='paused'" v-text="$ml.get('paused')">Pausado</a> 
                            </div>
                          </div>
                          <p class='d-flex align-items-center'>
                            <span class='align-self-center text-published' v-text="$ml.with($utils.formatData(item.createdAt, $ml.get('ln'))).get('publishedDaysAgo')">
                            </span>
                          </p>
                          <div class='actions d-flex flex-row'>
                            <VueCustomTooltip :label="$ml.get('ccpProgPriv')">
                              <span v-show="item.type == 'private'" class='ico ico-locked mr-1'> 
                                <img src="../../../../src/assets/icons/lock.svg" class="ico-13"/>
                              </span>
                            </VueCustomTooltip>
                            <VueCustomTooltip label="Vulnerability Disclosure Program">
                              <span v-if="item.type == 'vdp'" class='ico ico-locked ico-vdp mr-1' data-toggle='tooltip' data-placement='top' title='Programa Privado'>
                                VDP
                              </span>
                            </VueCustomTooltip>
                            <VueCustomTooltip :label="$ml.get('ccpProgPubli')">
                              <span v-show="item.type == 'public'" class='ico ico-locked mr-1'> 
                                <img src="../../../../src/assets/icons/unlock.svg" class="ico-13"/>
                              </span>
                            </VueCustomTooltip>
                            <VueCustomTooltip :label="$ml.get('managedProgram')">
                              <span v-show="item.managed" class='ico ico-managed mr-1'>
                                <img src='../../../assets/images/bughunt.svg' />
                              </span>
                            </VueCustomTooltip>
                            <VueCustomTooltip :label="$ml.get('protectedByNDA')">
                              <span v-if="item.program_nda" class="ico ico-nda mr-1">
                                <img src="../../../assets/icons/security-shield.svg" />
                              </span>
                            </VueCustomTooltip>
                            <VueCustomTooltip label="VPN">
                              <span v-if="item.vpn_required" class="ico ico-vpn mr-1">
                                <img src="../../../assets/images/vpn.png" />
                              </span>
                            </VueCustomTooltip>
                          </div>
                          <hr />
                          <div class='card-chart-body w-100'> 
                            <div class='row'>
                              <div class='col-5 border-r-d mb-2'>
                                <span class='pb-1' v-text="$ml.get('totalReports')">Total de relatórios</span>
                                <h6><a>{{item.totalReports}}</a></h6>
                              </div>
                              <div class='col-7 border-r-d pl-3 mb-2'>
                                <span class='pb-1' v-text="$ml.get('dashReportResolv')">Relatórios encerrados</span>
                                <h6><a>{{item.totalClosedReports}}</a></h6>
                              </div>
                              <div class='col-4 border-r-d pl-3 mb-2'>
                                <span class='pb-1' v-text="$ml.get('scope')">Escopo</span>
                                <h6><a>{{item.totalScopes}}</a></h6>
                              </div>
                              <div class='col-8 pl-3 mb-2'>
                                <span class='pb-1' v-text="$ml.get('rewards')">Recompensas</span> 
                                <div class="row mt-1">
                                  <span class="pr-2 d-flex align-items-center" v-if="item.offersBounty"> 
                                    <img src="../../../../src/assets/icons/dollar-sign.svg" class="ico-13 mr-1"/>
                                    <font>{{ $ml.get(item?.currency)}}</font> 
                                    <!-- <font v-text="$ml.get('money')">Dinheiro</font> -->
                                  </span>
                                  <span class="d-flex align-items-center" v-if="item.offersGift"> 
                                    <img src="../../../../src/assets/icons/gift.svg" class="ico-13 mr-1"/>
                                    <font v-text="$ml.get('gift')">Brinde</font> 
                                  </span> 
                                </div>
                              </div>
                            </div> 
                          </div>
                        </div> 
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="m-0" v-if="listProgram.length != index +1">
              </div> 
              
            </div> 
          </div>
           
          <div class='card mb-3'>
            <CardCreatProgram/> 
          </div>

        </div>
      </div>
      <!-- //- Cards do lado direito, Invite e Ranking -->
      <div class="col-24 col-md-5 pr-md-3 py-md-3 px-3 px-md-0">
        <section> 
          <div class='mb-3'>
            <Ranking/> 
          </div> 
          <div v-if="itensIvite.length" class='card mb-3'>
            <div class='card-header card-chart-mini'> 
              <div class='d-flex flex-row align-items-center'> 
                <div class='mr-2'>
                  <img src="../../../../src/assets/icons/paper-plane-black.svg" width="17" height="17" />
                </div>
                <span v-text="$ml.get('lastInvitations')">Ultimos Convites</span>
              </div> 
            </div>
            <div class='card-body py-1'> 
              <div v-for="(item, index) in itensIvite" :key="index" class='d-column flex-row'>
                <div :class="'h-profile d-flex align-items-center py-3 '+ (itensIvite.length == index +1? 'no':'')">
                  <div class='position-relative align-self-center align-items-center align-self-center w50'>
                    <object width="42" height="42" class="rounded-circle img-m" :data="item.program_avatar" type="image/png">
                      <img width="42" height="42" class="rounded-circle img-m" src="../../../assets/images/default.png" alt="Avatar">
                    </object> 
                  </div> 
                  <div class='flex-row align-items-start overflow-hidden'>
                    <div class='align-self-center '>
                      <h3 class='flex-wrap  d-block' v-text="item.username"></h3>
                      <p><a><span v-text="item.program_name"></span></a></p>
                    </div> 
                  </div>  
                </div> 
              </div> 
            </div> 
          </div>
        </section> 
      </div>
    </section> 
  </main>
</div>
</template>

<script> 
import Ranking from "../../../components/ranking";
import CompanyService from "../../../services/company.service"; 
import ProgramService from "../../../services/program.service"; 
  
export default {
  components: { 
    Ranking,
  },
  data() {
    return {
      title: "Program",

      approved_reports: 0,
      amount_of_scopes: 0,
      mediaRecomp: "R$00,00-R$00,00",

      listProgram:[],
      itensIvite: []
    };
  },
  created(){
    this.changeProgram();
    this.changeInvite();
    this.changeSummary();
  },
 
  methods: {
    changeProgram() {
      ProgramService.getProgram().then(
        (response) => {
          this.listProgram = response.data;   
        }
      );
    },
    changeInvite(){
      ProgramService.getInvites(1,3,'')
      .then(
        (response) => {  
          this.itensIvite = response.data.items;  
        }
      );
    },
    changeSummary(){
      CompanyService.getGeneralSummary()
      .then(
        (response) => { 
            this.approved_reports = response.data.approved_reports;
            this.amount_of_scopes = response.data.amount_of_scopes;
            this.mediaRecomp = (response.data.min_bounty == response.data.max_bounty ? this.convertMoney(response.data.min_bounty) : this.convertMoney(response.data.min_bounty)+' - '+ this.convertMoney(response.data.max_bounty));
        }
      );
    },

    convertMoney(money){
      money = parseFloat(money)
      return money.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },  
  },
};
</script>
<style scoped>
.overflow-hidden{ 
  overflow: hidden;
}
.w50{
  width: 50px !important; 
}
 
main section .h-profile img {
  margin-right: 13px !important;
}

</style>
 